import React from 'react'

import { Box, Skeleton } from '@mui/material'

import pageStyles from '../../RecipientTracking.styles'
import styles from './RecipientTrackingSkeleton.styles'

const RecipientTrackingSkeleton: React.FC = () => {
  return (
    <Box sx={pageStyles.pageWrapper}>
      <Box sx={styles.hero}>
        <Skeleton variant="rounded" height={14} width={120} sx={{ bgcolor: 'rgba(255,255,255,0.2)' }} />

        <Skeleton variant="rounded" height={32} width="60%" sx={{ bgcolor: 'rgba(255,255,255,0.25)' }} />

        <Skeleton variant="rounded" height={20} width="85%" sx={{ bgcolor: 'rgba(255,255,255,0.2)' }} />

        <Box sx={styles.stepperWrapper}>
          <Box sx={styles.stepperCard}>
            <Box sx={styles.stepRow}>
              <Skeleton variant="circular" height={36} width={36} />
              <Skeleton variant="rounded" height={2} sx={{ flex: 1 }} />
              <Skeleton variant="circular" height={36} width={36} />
              <Skeleton variant="rounded" height={2} sx={{ flex: 1 }} />
              <Skeleton variant="circular" height={36} width={36} />
            </Box>
          </Box>
        </Box>
      </Box>

      <Box sx={pageStyles.contentArea}>
        <Box sx={pageStyles.leftColumn}>
          <Box sx={styles.card}>
            <Box sx={styles.cardHeader}>
              <Skeleton variant="rounded" height={20} width={140} />
              <Skeleton variant="rounded" sx={styles.iconWrap} />
            </Box>
            <Box sx={styles.avatarRow}>
              <Skeleton variant="circular" sx={styles.avatarCircle} />
              <Box sx={styles.infoContent}>
                <Skeleton variant="rounded" height={18} width="60%" />
                <Skeleton variant="rounded" height={14} width="80%" />
              </Box>
            </Box>
            <Box sx={styles.divider} />
            <Box sx={styles.infoRow}>
              <Skeleton variant="rounded" sx={styles.infoIconWrap} />
              <Box sx={styles.infoContent}>
                <Skeleton variant="rounded" height={10} width={100} />
                <Skeleton variant="rounded" height={16} width="90%" />
                <Skeleton variant="rounded" height={14} width="70%" />
                <Skeleton variant="rounded" height={14} width="50%" />
              </Box>
            </Box>
            <Box sx={styles.divider} />
            <Box sx={{ ...styles.infoRow, alignItems: 'center' }}>
              <Skeleton variant="rounded" sx={styles.infoIconWrap} />
              <Box sx={styles.infoContent}>
                <Skeleton variant="rounded" height={10} width={60} />
                <Skeleton variant="rounded" height={16} width="55%" />
              </Box>
            </Box>
          </Box>

          <Box sx={styles.card}>
            <Box sx={styles.cardHeader}>
              <Skeleton variant="rounded" height={20} width={120} />
              <Skeleton variant="rounded" sx={styles.iconWrap} />
            </Box>
            <Box sx={styles.orderGrid}>
              <Box sx={styles.orderDataBox}>
                <Skeleton variant="rounded" height={10} width={90} />
                <Skeleton variant="rounded" height={18} width="75%" />
              </Box>
              <Box sx={styles.orderDataBox}>
                <Skeleton variant="rounded" height={10} width={95} />
                <Skeleton variant="rounded" height={18} width={50} />
              </Box>
            </Box>
            <Box sx={styles.orderDataBox}>
              <Skeleton variant="rounded" height={10} width={120} />
              <Skeleton variant="rounded" height={18} width={100} />
            </Box>
          </Box>
        </Box>

        <Box sx={pageStyles.rightColumn}>
          <Box sx={styles.card}>
            <Box sx={styles.cardHeader}>
              <Skeleton variant="rounded" height={20} width={160} />
              <Skeleton variant="rounded" sx={styles.itemsBadge} />
            </Box>
            <Box sx={styles.itemRow}>
              <Skeleton variant="rounded" sx={styles.itemImgBox} />
              <Box sx={styles.itemInfo}>
                <Skeleton variant="rounded" height={18} width="85%" />
                <Box sx={styles.itemMeta}>
                  <Skeleton variant="rounded" sx={styles.chip} />
                  <Skeleton variant="rounded" sx={styles.chip} />
                </Box>
              </Box>
            </Box>
            <Box sx={styles.divider} />
            <Box sx={{ ...styles.itemRow, paddingTop: 0 }}>
              <Skeleton variant="rounded" sx={styles.itemImgBox} />
              <Box sx={styles.itemInfo}>
                <Skeleton variant="rounded" height={18} width="75%" />
                <Box sx={styles.itemMeta}>
                  <Skeleton variant="rounded" sx={styles.chip} />
                  <Skeleton variant="rounded" sx={styles.chip} />
                  <Skeleton variant="rounded" sx={styles.chip} />
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default RecipientTrackingSkeleton
